// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2dfpT","rootCenter":"LoadMoreObserver_rootCenter__1l4ZL","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2A8wo"};